import {
   Component,
   ChangeDetectionStrategy,
   input,
   computed,
   inject
} from '@angular/core';
import { IPaymentInstrument } from '@appShared/interfaces/[Model-based]';
import { PaymentCardType_, PaymentInstrumentType_ } from '@appShared/services/lookup/[CodeGen]';
import { DateTimeService } from '@appShared/services';

@Component({
    selector: 'app-payment-instrument-display',
    templateUrl: './payment-instrument-display.component.html',
    styleUrls: ['./payment-instrument-display.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentInstrumentDisplayComponent {
   public readonly paymentInstrument = input.required<IPaymentInstrument>()

   private dateTimeService = inject(DateTimeService)
   public paymentCardImageUrl = computed(() => {
      let paymentInstrument = this.paymentInstrument()
      if (
         paymentInstrument.typeCode === PaymentInstrumentType_.PaymentCard
      ) {
         if (
            [
               PaymentCardType_.Amex,
               PaymentCardType_.Discover,
               PaymentCardType_.MasterCard,
               PaymentCardType_.VISA
            ].includes(paymentInstrument?.info.card?.typeCode || 0)
         ) {
            return paymentInstrument.sourceName
               ? `/assets/images/cc/${paymentInstrument.sourceName.toLowerCase()}.png`
               : ''
         }
      }

      return null
   })

   public paymentCardExpiration = computed(() => {
      let paymentInstrument = this.paymentInstrument()
      if (
         paymentInstrument.typeCode === PaymentInstrumentType_.PaymentCard
      ) {
         const ccExpiration = paymentInstrument.paymentCard.expiration

         if (ccExpiration?.length > 5) {
            return ccExpiration
               ? this.dateTimeService.formatDate(
                  new Date(ccExpiration),
                  'MM/YY'
               )
               : ''
         }
      }

      return null
   })
}
